var map = {
	"./black_belt.svg": "5be9",
	"./crown.svg": "09c4",
	"./edistribuzione.svg": "8c71",
	"./engineering.svg": "ca55",
	"./handcuffs.svg": "2a34",
	"./nhsmun.svg": "48b3",
	"./old_book.svg": "1ae6",
	"./slovakia.svg": "ebe8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4163";